import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyMessagingWins from './components/WhyMessagingWins';
import CommonMistakes from './components/CommonMistakes';
import WhyTextingDifferent from './components/WhyTextingDifferent';
import SkillsLearned from './components/SkillsLearned';
import RealChatAnalysis from './components/RealChatAnalysis';
import ChannelsSection from './components/ChannelsSection';
import AIinMessaging from './components/AIinMessaging';
import ProgramRoadmap from './components/ProgramRoadmap';
import WhyProgramsWork from './components/WhyProgramsWork';
import CaseStudies from './components/CaseStudies';
import SuitableFor from './components/SuitableFor';
import TrainingFormats from './components/TrainingFormats';
import CompanyResults from './components/CompanyResults';
import CTASection from './components/CTASection';
import WhyAlexeySivko from './components/WhyAlexeySivko';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';

const seoNavLinks = [
  { label: 'Программа', target: 'program' },
  { label: 'Кейсы', target: 'cases' },
  { label: 'Контакты', target: 'contact' },
  { label: 'FAQ', target: 'faq' },
];

export default function TextSalesTrainingPage() {
  return (
    <>
      
      <SeoTitle title="Продажи через переписку | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={seoNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <WhyMessagingWins />
        <CommonMistakes />
        <WhyTextingDifferent />
        <SkillsLearned />
        <RealChatAnalysis />
        <ChannelsSection />
        <AIinMessaging />
        <ProgramRoadmap />
        <WhyProgramsWork />
        <CaseStudies />
        <SuitableFor />
        <TrainingFormats />
        <CompanyResults />
        <CTASection />
        <WhyAlexeySivko />
        <FAQSection />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}